import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import s from "./Impreso.module.css";

import { Grid, CircularProgress } from "@mui/material";

import { useTranslation } from "react-i18next";
import { useReactToPrint } from "react-to-print";
import { Plantilla } from "./Plantilla";
import ordersService from "../../../../api/delivery/ordersServices";

export const ImpresoOrders = () => {
  let params = useParams();
  let componentRef = useRef();
  const { t } = useTranslation();
  const [data, setData] = useState({});
  const [readyAssets, setReadyAssets] = useState(false);
  const navigate = useNavigate();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => navigate("../ordenes-pedido"),
  });

  useEffect(() => {
    ordersService.getOrderById(params.id).then((response) => setData(response));
  }, []);

  useEffect(() => {
    if (data.id && readyAssets) {
      handlePrint();
    }
  }, [data, readyAssets]);

  return (
    <Grid container className={s.container}>
      <Grid item xs={10} className={s.loader}>
        <CircularProgress size={"4rem"} />
        <p>{t("loading")}</p>
      </Grid>

      {data?.id ? (
        <div ref={componentRef} className={s.forPrint}>
          <Plantilla data={data} assetsReady={setReadyAssets} />
        </div>
      ) : null}
    </Grid>
  );
};
